import React, { useState } from "react";
import Chatbot from './chatbot';
import "./chatbot.css";

const ChatbotWidget = () => {
  const [open] = useState(true);

  return (
    <>
      {open && (
        <div className="chatbot-popup">
          <Chatbot />
        </div>
      )}
    </>
  );
};

export default ChatbotWidget;
